<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Petty cash</div>
            <fieldset class="border p-3">
              <div>
                <form @submit.prevent="newPettycash()">
                  <div class="form-group">
                    <label>Account</label>
                    <select
                      class="form-control account_id"
                      @change="loadPettycash()"
                      required
                    >
                      <option value>Select account</option>
                      <option
                        v-for="accounttype in systemAccounttypes"
                        :value="accounttype.id"
                        :key="accounttype.id"
                      >
                        {{ accounttype.account_name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Petty cash date</label>
                    <input
                      type="date"
                      class="form-control date_amount"
                      placeholder="disbursed amount"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label>Petty cash amount</label>
                    <input
                      type="number"
                      class="form-control disbursed_amount"
                      placeholder="disbursed amount"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat creatingPettycash btn-rounded"
                  >
                    <i class="fa fa-plus"></i> create Pettycash
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-flat creatingPettycashLoader btn-rounded"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
            <div></div>

            <fieldset class="border p-3">
              <legend class="auto-wp">
                <small style="font-size: 15px; font-weight: bold"
                  >manage petty cashes</small
                >
              </legend>
              <button class="btn btn-success btn-roundec" @click="loadPetty()">
                <i class="fa fa-file-pdf-o"></i> PETTY CASH
              </button>
              <p></p>
              <div></div>

              <vue-good-table
                :columns="columns"
                :rows="systemPettycashes"
                :fixed-header="true"
                :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 6,
                  position: 'bottom',
                  perPageDropdown: [3, 7, 9],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }"
              ></vue-good-table>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account name",
          field: "account_name",
          type: "text",
        },
        {
          label: "Disbursed amount",
          field: "disbursed_amount",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by petty cash amount",
          },
        },
        {
          label: "Balance amount",
          field: "balance_amount",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by balance amount",
          },
        },
      ],
    };
  },
  created() {
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters(["systemAccounttypes", "systemPettycashes"]),
  },
  methods: {
    ...mapActions([
      "newPettycash",
      "loadAccounttypes",
      "loadPettycash",
      "loadPetty",
    ]),
  },
};
</script>
<style scoped>
.creatingPettycashLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pettycashes/pettycash.vue